<script>
import Layout from '@/router/layouts/main';
import textMixin from '../../../../mixins/textMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
import DeleteButton from '@/components/widgets/buttons/delete-button';
import GridComponent from '@/components/widgets/grids/pagination-grid';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Items',
  },
  mixins: [textMixin],
  components: {
    Layout,
    Loading,
    DeleteButton,
    GridComponent,
  },
  data() {
    return {
      isLoading: false,
      showNewItemsOnly: false,
      searchText: '',
      items: [
        {
          text: 'items',
          href: '/items',
        },
        {
          text: '',
          active: true,
        },
      ],
      list: [],
      statues: [
        {
          code: 'NEW_ITEM',
          name: this.$t('items.newItem'),
          html:
            '<span class="badge badge-danger badge-pill" style="font-size: 1em">' +
            this.$t('items.newItem') +
            '  <small> <i class="fas fa-times"></i></small></span>',
        },
        {
          code: 'PENDING',
          name: this.$t('general.pending'),
          html:
            '<span class="badge badge-warning badge-pill" style="font-size: 1em">' +
            this.$t('general.pending') +
            '...</span>',
        },
        {
          code: 'STANDARD',
          name: '',
          html: '<span></span>',
        },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      ItemsRepository.getAll()
        .then((response) => {
          this.list = response.data.data.map((x) => {
            return this.addExtraFields(x);
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    addExtraFields(item) {
      item.isLoading = false;
      item.deleteError = false;
      return item;
    },
    edit(idPublic) {
      this.$router.push({ name: 'editItem', params: { idPublic } });
    },
    create() {
      this.$router.push({ name: 'createItem' });
    },
    cancelSearch() {
      this.searchText = '';
    },
    deleteItem(item) {
      item.isLoading = true;
      ItemsRepository.delete(item.idPublic)
        .then(() => {
          let foundIndex = this.list.findIndex(
            (x) => x.idPublic == item.idPublic
          );
          this.list.splice(foundIndex, 1);
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          item.deleteError = true;
          item.isLoading = false;
        });
    },
    removeNewItemFlag(element) {
      element.isLoading = true;
      ItemsRepository.update({ ...element, isNewItem: false }, element.idPublic)
        .then((resp) => {
          let foundIndex = this.list.findIndex(
            (x) => x.idPublic == resp.data.idPublic
          );
          this.list = [
            ...this.list.slice(0, foundIndex),
            { ...resp.data, isLoading: false, isNewItem: false },
            ...this.list.slice(foundIndex + 1),
          ];
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.loadData();
        });
    },
  },
  computed: {
    itemListComputed() {
      return this.list
        .filter((x) => this.showNewItemsOnly == false || x.isNewItem)
        .filter((item) => {
          const code = item.code.toLowerCase();
          const name = item.name.toLowerCase();
          const searchTerms = this.searchText.toLowerCase().split(' ');
          let isValidElement = true;

          for (const x of searchTerms) {
            if (!code.includes(x) && !name.includes(x)) {
              isValidElement = false;
            }
          }

          return isValidElement;
        })
        .map((item) => {
          if (item.isLoading) {
            item.itemStatus = 'PENDING';
          } else if (item.isNewItem) {
            item.itemStatus = 'NEW_ITEM';
          } else {
            item.itemStatus = 'STANDARD';
          }

          let statusHTMLIndex = this.statues.findIndex(
            (x) => x.code == item.itemStatus
          );
          if (statusHTMLIndex >= 0) {
            item.itemStatusHTML = this.statues[statusHTMLIndex].html;
          } else {
            item.statusHTML =
              '<span class="badge badge-danger badge-pill" style="font-size: 1em">' +
              this.$t('general.error').toUpperCase() +
              '</span>';
          }

          return item;
        });
    },
    fieldsComputed() {
      return [
        {
          key: 'code',
          label: this.$t('general.code'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('general.name'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('general.status'),
          sortable: true,
          class: 'centered-field',
          sortByFormatted: true,
          formatter: (value, key, item) => {
            return item.isNewItem;
          },
        },
        {
          key: 'minQuantity',
          label: this.$t('items.minQty'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'categoryName',
          label: this.$t('categories.category'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplier'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'edit',
          label: this.$t('general.edit'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'delete',
          label: this.$t('general.delete'),
          class: 'centered-field',
          sortable: true,
        },
      ];
    },
  },
};
</script>

<template>
  <Layout :title="$t('items.items')">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div class="topbar">
      <b-form-group
        id="fieldset-1"
        :label="$t('general.search')"
        label-for="searchInput"
      >
        <b-form-input
          id="searchInput"
          type="text"
          style="min-width: 300px"
          :placeholder="$t('general.search')"
          @keydown.escape.prevent="cancelSearch()"
          v-model="searchText"
      /></b-form-group>

      <b-form-checkbox
        id="checkbox-1"
        v-model="showNewItemsOnly"
        name="checkbox-1"
        style="margin-bottom: 16px; margin-left: 20px"
        switch
      >
        {{ $t('items.showNewOnly') }}
      </b-form-checkbox>

      <b-form-group id="fieldset-2" style="margin-left: auto">
        <b-button
          style="height: 40px; margin-top: 28px"
          @click="create()"
          variant="primary"
        >
          {{ $t('general.add') }}
        </b-button>
      </b-form-group>
    </div>

    <GridComponent
      id="items-grid"
      :fields="fieldsComputed"
      :items="itemListComputed"
    >
      <template #cell(code)="data">
        <div v-html="highlightMatches(data.value, searchText)"></div>
      </template>

      <template #cell(name)="data">
        <div v-html="highlightMatches(data.value, searchText)"></div>
      </template>

      <template #cell(status)="data">
        <div
          style="cursor: pointer; font-size: 1.05em"
          @click="removeNewItemFlag(data.item)"
          v-html="data.item.itemStatusHTML"
        ></div>
      </template>

      <template #cell(edit)="data">
        <i
          class="fas fa-pencil-alt text-success pl-2 pr-2"
          @click="edit(data.item.idPublic)"
          style="cursor: pointer; font-size: 1.3em"
        ></i>
      </template>

      <template #cell(delete)="data">
        <DeleteButton
          :key="data.item.idPublic"
          :error="!data.item.isLoading && data.item.deleteError"
          @clicked="deleteItem(data.item)"
        />
      </template>
    </GridComponent>
  </Layout>
</template>

<style scoped>
.topbar {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
</style>
